import {ProgressViewState} from "../../../../../../models";
import dayjs from "dayjs";
import {toCurrencyString} from "../../../../../../assets/scripts/string-functions";

export default class{
    constructor({activeUploads, uploads, progress, adminStatus, isActive, data, personalTitle}) {
        this.errors = []
        this.uploads = uploads;
        this.hasMoreUploadsRequested = progress?.alertBody && progress.alertBody.length
        this.hasMoreUploadsRequestedBySystem = this.hasMoreUploadsRequested && progress?.alertAuthor === 'system';
        this.isComplete = !adminStatus

        if (activeUploads.length === 0) {
            this.errors.push(`No active uploads`)
        }
        else if (activeUploads.filter(it=>it.isVerifiable).some(upload => upload.problems.length>0).length > 0) {
            this.errors.push(`Uploads have problems`);
        }
        this.pendingUploads = (() => {
            return activeUploads.filter(upload => upload.isPending)
        })()
        this.numberOfPendingUploads = (() => {
            return this.pendingUploads.length
        })()
        this.numberForAdvisorReview = (() => {
            return activeUploads.filter(upload => upload.needsAdvisorReview).length
        })()
        this.numberWithMissingData = (() => {
            return activeUploads.filter(upload => !upload.allValuesAnswered).length
        })()

        this.adminStatus = (()=>{

            if (!isActive){
                return adminStatus
            }
            if (!activeUploads || !activeUploads.length) {
                return {
                    text: 'NO UPLOADS',
                    color: "default"
                };
            }
            if (this.numberOfPendingUploads > 0){
                return {
                    text: 'PENDING UPLOADS',
                    color: "red"
                };
            }
            if (this.numberForAdvisorReview > 0) {
                return {
                    text: 'FOR ADVISOR REVIEW',
                    color: "volcano"
                };
            }

            if (activeUploads.length && this.errors.length){
                return {
                    text: 'UPLOAD ERRORS',
                    color: "red"
                };
            }

            if (this.hasMoreUploadsRequested && !this.progress?.viewState === ProgressViewState.COMPLETE) {
                if (progress.alertAuthor === 'system'){
                    return {
                        text: 'AUTO MORE REQUESTED',
                        color: "orange"
                    };
                }
                return {
                    text: 'MANUAL MORE REQUESTED',
                    color: "orange"
                };
            }
        })()

        this.coverNoteQueries = (() => {
            return activeUploads.flatMap(upload => {
                return upload.queries.flatMap(query => {
                    if (!query.excludedOn){
                        let depositStrings = ['deposit', 'transfer in', 'transfer from'];
                        let outgoingStrings = ['outgoing', 'withdrawal', 'transfer out', 'transfer to',  'payment to', 'payment for'];
                        let title = query.title || '';
                        if (query?.amount && depositStrings.some(str=> (query.title || '').toLowerCase().includes(str))) {
                            title = `CR ${toCurrencyString(query.amount, data?.currency || '€')}`;
                        }
                        else if (query?.amount && outgoingStrings.some(str=> (query.title || '').toLowerCase().includes(str))) {
                            title = `DR ${toCurrencyString(query.amount, data?.currency || '€')}`;
                        }
                        return [{
                            date: query.date ? dayjs(query.date, "YYYY-MM-DD").format('D MMM YYYY') : null,
                            title,
                            text: [query.lenderAnswer || 'NO COMMENT PROVIDED'],
                        }]
                    }
                    return []
                }).sort((a,b)=>{
                    if (a.date && b.date) {
                        return dayjs(a.date, "D MMM YYYY").unix() - dayjs(b.date, "D MMM YYYY").unix()
                    }
                    return 0
                })
            })
        })()

        this.queries = activeUploads.flatMap(upload => upload.queries)
    }

    getRange = () => {
        const withRanges = this.uploads.filter(it => it.isActive && it.isVerifiable && it.dateData?.range)
        if (!withRanges.length) {
            return null;
        }


        const start = withRanges[0].dateData?.range?.start;
        const end = withRanges[withRanges.length - 1].dateData?.range?.end;
        return {
            from: start,
            to: end
        };
    }

    get dateOfLastUpload() {
        if (!this.uploads || !this.uploads.length) {
            return null;
        }
        const lastUpload = this.uploads.sort((a, b) => b.createdAt - a.createdAt)[0];
        return lastUpload?.createdAt ? dayjs(lastUpload.createdAt) : null;
    }

}